function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "news",
  transform: "translate(0.000000, -2.000000)",
  fill: "#3B3A42"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 1.999800)"
}, React.createElement("path", {
  d: "M5.9999,3.7342 L5.9999,18.9958682 L2.0009,18.9945337 L2.0009,3.7462 C1.98882703,2.78800027 2.74558037,2.01211827 3.69158256,2.00011957 L3.7019,2.0002 L4.30359151,2.0005804 C5.24422799,2.02066062 5.9999,2.78972847 5.9999,3.7342 Z M5.9999,20.9958683 L5.9999,23.9738649 L9.992564,23.9791991 L26.9993708,23.9881999 L27.9999,23.9887294 L27.9999,3.7582 L28.0001837,3.74421228 C28.0006024,3.71021322 28.0006024,3.71021322 27.9983604,3.64772998 C27.9834416,1.64463888 26.3067238,-0.00455708704 24.2562221,0.0132376538 L4.32197022,0.000593116862 C4.30829259,0.000391089466 4.29459707,0.000262569888 4.28088403,0.000207936288 L3.7025322,0.000200199841 L3.6789,0.0002 C1.615916,0.0262855854 -0.0250231827,1.70870324 0.000980426872,3.75888256 L0.000899999999,19.9942 L0.000899999999,20.9938663 L5.9999,20.9958683 Z M24.2642678,2.0131998 C25.2189681,2.00495803 25.9923575,2.76565295 25.9999321,3.71121042 L26.0002855,3.7218714 L25.9999,3.7582 L25.9999,21.9876706 L9.99442922,21.9792001 L7.9999,21.9765352 L7.9999,3.7342 C7.9999,3.10941951 7.84637428,2.52030717 7.57492477,2.00264858 L24.2642678,2.0131998 Z",
  id: "Stroke-1",
  fillRule: "nonzero"
}), React.createElement("polygon", {
  id: "Fill-3",
  points: "9.994 9.994 23.994 9.994 23.994 5.994 9.994 5.994"
}), React.createElement("polygon", {
  id: "Fill-5",
  points: "9.994 17.994 15.994 17.994 15.994 11.994 9.994 11.994"
}), React.createElement("polygon", {
  id: "Fill-6",
  points: "17.994 13.994 23.994 13.994 23.994 11.994 17.994 11.994"
}), React.createElement("polygon", {
  id: "Fill-7",
  points: "17.994 17.994 23.994 17.994 23.994 15.994 17.994 15.994"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "24px",
    viewBox: "0 0 28 24",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/news.39a5dc69.svg";
export { SvgComponent as ReactComponent };